import React from 'react'

const HeaderLogo = () => {
  return (
    <div>
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
            <div style={{ width: 42, height: 42, borderRadius: "12px", background: "linear-gradient(135deg, #4FC3F7, #0288D1)", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 4px 15px rgba(79,195,247,0.3)", fontWeight: "900", fontSize: 13, color: "#fff", letterSpacing: "0.5px", fontFamily: "monospace" }}>
                NWK
            </div>
        <div>
            <div style={{ color: "#fff", fontSize: 18, fontWeight: "bold" }}>
                NewWeekKanban
            </div>
                <div style={{ color: "#78909C", fontSize: 12, marginTop: 2 }}>
                    {new Date().toLocaleDateString("pt-BR", { weekday: "long", day: "numeric", month: "long" })}
                </div>
            </div>
        </div>
    </div>
  )
}

export default HeaderLogo